import { render, staticRenderFns } from "./OpenQuestionnaireFormItemOpenQuestion.vue?vue&type=template&id=4d629154&scoped=true&"
import script from "./OpenQuestionnaireFormItemOpenQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionnaireFormItemOpenQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestionnaireFormItemOpenQuestion.vue?vue&type=style&index=0&id=4d629154&lang=scss&scoped=true&"
import style1 from "./OpenQuestionnaireFormItemOpenQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d629154",
  null
  
)

export default component.exports